import React from "react";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { Box } from "UI/Box";
import { Button } from "UI/Button";
import { TextInput } from "UI/Form/TextInput";
import { Grid } from "UI/Grid";
import { Modal } from "UI/Modal";
import { Typography } from "UI/Typography";

type Props<T extends { notification_email: string }> = {
  onClose: () => void;
  form: FormikProps<T>;
};

export const ModalNotificationEmail = <T extends { notification_email: string }>({
  onClose,
  form,
}: Props<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal
      open
      title={t("Email для сповіщень")}
      onClose={onClose}
      hideHeader
      width={500}
    >
      <Box p={32}>
        <Typography variant="subtitle1" mb={16}>
          {t("Укажите email для получения уведомления")}
        </Typography>
        <TextInput
          label={t("Email-адрес для уведомлений")}
          value={form.values.notification_email}
          onChange={(val) => form.setFieldValue("notification_email", val)}
          onBlur={() => form.setFieldTouched("notification_email", true)}
          name="notification_email"
          helperText={
            form.touched.notification_email &&
            (form.errors.notification_email as string)
          }
          error={
            form.touched.notification_email
              ? (form.errors.notification_email as string)
              : ""
          }
        />
        <Grid container mt={16} hSpace={16}>
          <Grid item>
            <Button variant="outlined" size="small" onClick={onClose}>
              {t("Отмена")}
            </Button>
          </Grid>
          <Grid item sm="fill">
            <Button
              size="small"
              fullwidth
              disabled={form.isSubmitting}
              type="submit"
              onClick={() => form.handleSubmit()}
            >
              {t("Подтвердить")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};
